import * as React from 'react'

import { LoansQueryResult, Loan } from '../../components/queries/LoansQuery'
import { IDefinition, Datagrid } from '../../components/Datagrid'
import { loan as commons } from '../../components/DatagridCommons'

type UserClosedLoansTableProps = {
  loans: LoansQueryResult['loans']
}

const definition: IDefinition<Loan> = {
  columns: [
    commons.columns.date,
    commons.columns.creditorDebtors,
    commons.columns.description,
    commons.columns.loanedAmount,
    commons.columns.payed,
    commons.columns.toPay,
    commons.columns.detailAction
  ],
  idGetter: data => data.id,
  defaultSort: 'date',
  rowContainer: commons.rowContainer
}

const UserClosedLoansTable: React.SFC<UserClosedLoansTableProps> = ({
  loans
}) => <Datagrid definition={definition} data={loans} />

export default UserClosedLoansTable



// WEBPACK FOOTER //
// ./src/screens/dashboard/UserClosedLoansTable.tsx